import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import DetailsTable from "./DetailsTable";
import usePopup from "../../../../../hooks/usePopup";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { getBilledDetailsService } from "../../Service";
import { getbilledItemDetailsResponseType } from "../../type";
import { PaymentContext, PaymentContextType } from "../context/Listprovider";

const AmountCard = () => {
  const { CustomModal } = usePopup();
  const [open, setOpen] = useState(false);
  const { setAmountDetails } = useContext(PaymentContext) as PaymentContextType;
  const { billingId } = useParams();
  const [billedDetails, setBilledDetails] = useState<getbilledItemDetailsResponseType | null>(null);

  const { mutate: getbillDetails } = useMutation(getBilledDetailsService, {
    onSuccess: (data) => {
      setBilledDetails(data.response);
      if (data?.response?.amountDetails?.totalAmount) {
        setAmountDetails(data.response.amountDetails);
      }
    },
  });

  useEffect(() => {
    if (billingId) {
      getbillDetails({ billId: parseInt(billingId, 10) });
    }
  }, [billingId, getbillDetails]);

  const amountDetails = billedDetails?.amountDetails;

  const details = [
    { label: "Total Amount", value: amountDetails?.totalAmount?.toFixed(2) || "0" },
    { label: "Ins Discount Amount", value: amountDetails?.insDiscount?.toFixed(2) || "0" },
    { label: "Ins Amount", value: amountDetails?.insAmount.toFixed(2) || "0"  },
    { label: "Priority Patient", value: amountDetails?.priorityPatient?"yes":"No" },
    { label: "Pat Share", value: amountDetails?.patShare?.toFixed(2) || "0" },
  ];

  return (
    <Paper elevation={4} className="p-4">
      <div className="flex items-center gap-x-4">
        <Typography
          variant="subtitle1"
          color="textPrimary"
          sx={{ fontWeight: "bold", marginBottom: 1, color: "primary.main" }}
        >
          Amount Details
        </Typography>
        <Button
          onClick={() => setOpen(true)}
          className="bg-primary text-white"
          variant="contained"
          size="small"
          sx={{ marginBottom: 1 }}
        >
          View Billed Items
        </Button>
      </div>

      <Divider sx={{ marginBottom: 2 }} />

      <Grid container spacing={2}>
        {details.map((item, index) => (
          <Grid item xs={2} key={index}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
              {item.label}:{" "}
              <Typography component="span" sx={{color:"black", fontWeight: "1000" }}>
                {item?.value ?? ""}
              </Typography>
            </Typography>
          </Grid>
        ))}
      </Grid>

      <div className="ml-10">
        <CustomModal title="View Billed Items" open={open} setOpen={setOpen}>
          <Box>
            {billedDetails?.billingDetails && <DetailsTable data={billedDetails.billingDetails} />}
          </Box>
        </CustomModal>
      </div>
    </Paper>
  );
};

export default AmountCard;
